module.exports = __webpack_public_path__ + "static/img/earn01.9da8d84c.webp";